import {
	urlForTimedShuttlesDefinitions, urlForTimedShuttlesHistory,
	urlForTimedShuttlesOccurrencePolicies, urlForTimedShuttlesOccurrencePolicy
} from "@src/features/timed-shuttles/timed-shuttles-api-urls-old-endpoint";
import {
	type CreateOccurrencePolicyArgs,
	type CreateOccurrencePolicyRequestBody,
	type DeleteOccurrencePolicyArgs,
	type GetAllShuttleDefinitionsArgs,
	type GetTimedShuttlesHistoryArgs,
	type GetTimedShuttlesHistoryResponse
} from "@src/features/timed-shuttles/timed-shuttles-dtos";
import {type AllShuttleDefinitions} from "@src/features/timed-shuttles/timed-shuttles-models";
import {appApi} from "@src/integrations/redux/app-api";
import {HTTP_METHODS} from "@src/utils/network-constants";


export const timedShuttlesApi = appApi.injectEndpoints({
	endpoints: (builder) => ({
		createTimedShuttleOccurrencePolicy: builder.mutation<void, CreateOccurrencePolicyArgs>({
			query: (args) => ({
				url: urlForTimedShuttlesOccurrencePolicies(args.spaceId, args.definitionId),
				method: HTTP_METHODS.POST,
				body: {
					dayOfWeek: args.dayOfWeek,
					startTime: args.startTime
				} satisfies CreateOccurrencePolicyRequestBody
			})
		}),
		deleteTimedShuttleOccurrencePolicy: builder.mutation<void, DeleteOccurrencePolicyArgs>({
			query: (args) => ({
				url: urlForTimedShuttlesOccurrencePolicy(args.spaceId, args.definitionId, args.policyId),
				method: HTTP_METHODS.DELETE
			})
		}),
		getTimedShuttlesHistory: builder.query<GetTimedShuttlesHistoryResponse, GetTimedShuttlesHistoryArgs>({
			query: (args) => ({
				url: urlForTimedShuttlesHistory(args.spaceId, args.date, args.pageNumber, args.pageSize),
				method: HTTP_METHODS.GET
			})
		}),
	}),
	overrideExisting: "throw"
});


export const {
	useCreateTimedShuttleOccurrencePolicyMutation,
	useDeleteTimedShuttleOccurrencePolicyMutation,
	useGetTimedShuttlesHistoryQuery,
} = timedShuttlesApi;
